import {
  faRegularAddressCardCircleCheck,
  faRegularAnglesDownUp,
  faRegularChecklistSection,
  faRegularCircleUserCircleCheck,
  faRegularDsChevronDown,
  faRegularFileLinesPen,
  faRegularFileMagnifyingGlass,
  faRegularFolderCircleArrowRight,
  faSolidAddressCardCircleCheck,
  faSolidCircleUserCircleCheck,
} from '@awesome.me/kit-da13514c94/icons/kit/custom'

export const kitLibrary = [
  faRegularAddressCardCircleCheck,
  faRegularAnglesDownUp,
  faRegularChecklistSection,
  faRegularCircleUserCircleCheck,
  faRegularDsChevronDown,
  faRegularFileLinesPen,
  faRegularFileMagnifyingGlass,
  faRegularFolderCircleArrowRight,
  faSolidAddressCardCircleCheck,
  faSolidCircleUserCircleCheck,
]
